module.exports = __webpack_public_path__ + "static/img-boy-hexapod-59c9808570f2040d45b56dc344f49858.jpg";